import Vue from 'vue'
import Router from 'vue-router'
import Venues from '@/views/Venues.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/venues/',
      name: 'venues',
      component: Venues,
      children: [
        {
          path: '/venues/:venueId',
          name: 'venue',
          component: Venues
        },
      ]
    },
    {
      path: '/',
      redirect: '/venues'
    }
  ]
})
